import React from 'react';
import { Box } from '@mui/material';

/**
 * Renders the lobby background media inside the canvas.
 * Handles image, gif, and video types correctly.
 * All children are absolutely positioned to fill the parent.
 */
export function CanvasBackground({ lobby }) {
  if (!lobby?.bgUrl) {
    return (
      <Box
        sx={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(135deg, #1a2540 0%, #2d4a6b 50%, #1a3050 100%)',
        }}
      />
    );
  }

  if (lobby.bgType === 'video') {
    return (
      <video
        key={lobby.bgUrl}
        autoPlay
        muted
        loop
        playsInline
        src={lobby.bgUrl}
        style={{
          position: 'absolute', inset: 0,
          width: '100%', height: '100%',
          objectFit: 'cover',
          pointerEvents: 'none',
        }}
      />
    );
  }

  // image or gif — CSS background-image handles both
  return (
    <Box
      sx={{
        position: 'absolute', inset: 0,
        backgroundImage: `url(${lobby.bgUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    />
  );
}